export const STORE_FILTERS = [
  { key: "all", label: "Show All" },
  { key: "free-spins", label: "Free Spins" },
  { key: "vip", label: "Bonus" },
  { key: "mystery", label: "Mystery" },
  { key: "tournaments", label: "Tournament" },
  { key: "cash", label: "Cash" },
];

function getTagClass(tag) {
  const t = (tag || "").toUpperCase();
  if (t === "HOT") return "hot";
  if (t === "NEW") return "new";
  if (t === "VIP") return "vip";
  if (t === "LIMITED") return "limited";
  if (t === "VIP DROP") return "vip";
  if (t === "DIAMOND VIP ONLY") return "vip";
  return "";
}

function getDefaultDisplayMode(category, item) {
  if (item?.displayMode) return item.displayMode;
  if (category === "mystery") return "illust";
  return "typo";
}

export const STORE_MYSTERY_PRIZES = {
  "Bronze Chest": [
    { artId: "art-spins", label: "25 FREE SPINS", sub: "Starlight Princess" },
    { artId: "art-spins", label: "50 FREE SPINS", sub: "Sweet Bonanza" },
    { artId: "art-coins", label: "€2 BONUS CASH", sub: "5× wagering" },
    { artId: "art-coins", label: "€5 BONUS CASH", sub: "5× wagering" },
  ],
  "Silver Chest": [
    { artId: "art-spins", label: "75 FREE SPINS", sub: "Gates of Olympus" },
    { artId: "art-spins", label: "150 FREE SPINS", sub: "Sweet Bonanza" },
    { artId: "art-coins", label: "€10 BONUS CASH", sub: "5× wagering" },
    { artId: "art-coins", label: "€20 BONUS CASH", sub: "5× wagering" },
    { artId: "art-ticket", label: "WEEKLY RACE ENTRY", sub: "€5,000 prize pool" },
  ],
  "Gold Chest": [
    { artId: "art-spins", label: "300 FREE SPINS", sub: "Big Bass Bonanza" },
    { artId: "art-spins", label: "500 FREE SPINS", sub: "Sugar Rush" },
    { artId: "art-coins", label: "€50 BONUS CASH", sub: "5× wagering" },
    { artId: "art-coins", label: "€100 BONUS CASH", sub: "5× wagering" },
    { artId: "art-ticket", label: "HIGH ROLLER ENTRY", sub: "€15,000 pool" },
  ],
  "Diamond Vault": [
    { artId: "art-spins", label: "1,000 FREE SPINS", sub: "Free Spin Frenzy mix" },
    { artId: "art-coins", label: "€500 BONUS CASH", sub: "No wagering" },
    { artId: "art-diamond", label: "€1,000 CASHBACK", sub: "Paid as real cash" },
    { artId: "art-crown", label: "VIP LOUNGE PASS", sub: "Seven days access" },
  ],
};

export const STORE_ITEMS_MOCK = [
  // Mystery (wide hero)
  {
    id: "mystery-diamond",
    category: "mystery",
    displayMode: "illust",
    isWide: true,
    name: "Diamond Vault",
    title: "THE DIAMOND VAULT",
    headline: "€1,000 CASHBACK",
    desc: "One key, one door, three possible rewards inside. Anywhere from 500 free spins to a €1,000 real-cash cashback. Only 3 keys left in this rotation.",
    tag: "VIP DROP",
    tagClass: getTagClass("VIP DROP"),
    artId: "art-vault",
    cost: 8000,
    timerText: "Ends in 2h 14m",
    stockPct: 18,
    tier: "diamond",
    tierClass: "tier-diamond",
  },
  // Free spins
  {
    id: "fs-50-star",
    category: "free-spins",
    displayMode: "typo",
    name: "50 FS · Starlight Princess",
    title: "STARLIGHT PRINCESS",
    headline: "50 FREE SPINS",
    desc: "Fifty spins at €0.20 per spin. Seven-day expiry, plenty in stock.",
    tag: "NEW",
    tagClass: getTagClass("NEW"),
    artId: "art-spins",
    accentPos: "tl",
    bigText: "50",
    bigSize: "xl",
    subLabel: "FREE SPINS",
    cost: 200,
    timerText: "In stock",
    stockPct: 92,
  },
  {
    id: "fs-100-go",
    category: "free-spins",
    displayMode: "typo",
    name: "100 FS · Gates of Olympus",
    title: "GATES OF OLYMPUS",
    headline: "100 FREE SPINS",
    desc: "One hundred spins at €0.20 per spin. Seven-day expiry.",
    artId: "art-spins",
    accentPos: "tr",
    bigText: "100",
    bigSize: "xl",
    subLabel: "FREE SPINS",
    cost: 500,
    timerText: "In stock",
    stockPct: 84,
  },
  {
    id: "fs-100-wanted",
    category: "free-spins",
    displayMode: "typo",
    name: "100 FS · Wanted Dead",
    title: "WANTED DEAD OR A WILD",
    headline: "100 FREE SPINS",
    desc: "One hundred spins on Wanted Dead or a Wild at €0.20 per spin.",
    artId: "art-spins",
    accentPos: "bl",
    bigText: "100",
    bigSize: "xl",
    subLabel: "FREE SPINS",
    cost: 550,
    timerText: "In stock",
    stockPct: 78,
  },
  {
    id: "fs-200-sweet",
    category: "free-spins",
    displayMode: "typo",
    name: "200 FS · Sweet Bonanza",
    title: "SWEET BONANZA",
    headline: "200 FREE SPINS",
    desc: "Two hundred spins at €0.20 per spin. Seven-day expiry, 42 packs left.",
    tag: "HOT",
    tagClass: getTagClass("HOT"),
    artId: "art-spins",
    accentPos: "br",
    bigText: "200",
    bigSize: "xl",
    subLabel: "FREE SPINS",
    cost: 800,
    timerText: "Ends in 2d",
    stockPct: 42,
  },
  {
    id: "fs-200-bass",
    category: "free-spins",
    displayMode: "typo",
    name: "200 FS · Big Bass Bonanza",
    title: "BIG BASS BONANZA",
    headline: "200 FREE SPINS",
    desc: "Two hundred spins on Big Bass Bonanza at €0.20 per spin.",
    artId: "art-spins",
    accentPos: "tl",
    bigText: "200",
    bigSize: "xl",
    subLabel: "FREE SPINS",
    cost: 850,
    timerText: "In stock",
    stockPct: 70,
  },
  {
    id: "fs-300-sugar",
    category: "free-spins",
    displayMode: "typo",
    name: "300 FS · Sugar Rush",
    title: "SUGAR RUSH",
    headline: "300 FREE SPINS",
    desc: "Three hundred spins on Sugar Rush. Seven-day expiry.",
    artId: "art-spins",
    accentPos: "cn",
    bigText: "300",
    bigSize: "xl",
    subLabel: "FREE SPINS",
    cost: 1200,
    timerText: "In stock",
    stockPct: 65,
  },
  {
    id: "fs-500-fruit",
    category: "free-spins",
    displayMode: "typo",
    name: "500 FS · Fruit Party",
    title: "FRUIT PARTY",
    headline: "500 FREE SPINS",
    desc: "Five hundred spins on Fruit Party at €0.20 per spin.",
    artId: "art-spins",
    accentPos: "tr",
    bigText: "500",
    bigSize: "xl",
    subLabel: "FREE SPINS",
    cost: 1900,
    timerText: "In stock",
    stockPct: 50,
  },
  {
    id: "fs-1000-frenzy",
    category: "free-spins",
    displayMode: "typo",
    name: "1000 FS · Frenzy",
    title: "FREE SPIN FRENZY",
    headline: "1,000 FREE SPINS",
    desc: "One thousand spins across a curated mix of Pragmatic and Hacksaw titles.",
    tag: "VIP",
    tagClass: getTagClass("VIP"),
    artId: "art-spins",
    accentPos: "cn",
    bigText: "1,000",
    bigSize: "",
    subLabel: "FREE SPINS",
    cost: 3500,
    timerText: "Ends in 4d",
    stockPct: 25,
  },
  // Cash
  {
    id: "cash-5",
    category: "cash",
    displayMode: "typo",
    name: "€5 Bonus",
    title: "CASH BONUS",
    headline: "€5 BONUS",
    desc: "€5 in bonus cash with 5× wagering and a seven-day expiry.",
    artId: "art-coins",
    accentPos: "br",
    bigText: "€5",
    bigSize: "xl",
    subLabel: "BONUS CASH",
    cost: 400,
    timerText: "In stock",
    stockPct: 88,
  },
  {
    id: "cash-10",
    category: "cash",
    displayMode: "typo",
    name: "€10 Bonus",
    title: "CASH BONUS",
    headline: "€10 BONUS",
    desc: "€10 in bonus cash with 5× wagering and a seven-day expiry.",
    artId: "art-coins",
    accentPos: "tl",
    bigText: "€10",
    bigSize: "xl",
    subLabel: "BONUS CASH",
    cost: 800,
    timerText: "In stock",
    stockPct: 75,
  },
  {
    id: "cash-25",
    category: "cash",
    displayMode: "typo",
    name: "€25 Bonus",
    title: "CASH BONUS",
    headline: "€25 BONUS",
    desc: "€25 in bonus cash with 5× wagering and a seven-day expiry. 18 left.",
    tag: "HOT",
    tagClass: getTagClass("HOT"),
    artId: "art-coins",
    accentPos: "tr",
    bigText: "€25",
    bigSize: "xl",
    subLabel: "BONUS CASH",
    cost: 2200,
    timerText: "Ends in 4h",
    stockPct: 36,
  },
  {
    id: "cash-50",
    category: "cash",
    displayMode: "typo",
    name: "€50 Bonus",
    title: "CASH BONUS",
    headline: "€50 BONUS",
    desc: "€50 in bonus cash with 5× wagering and a seven-day expiry.",
    artId: "art-coins",
    accentPos: "bl",
    bigText: "€50",
    bigSize: "xl",
    subLabel: "BONUS CASH",
    cost: 4000,
    timerText: "In stock",
    stockPct: 80,
  },
  {
    id: "cash-100",
    category: "cash",
    displayMode: "typo",
    name: "€100 Bonus",
    title: "CASH BONUS",
    headline: "€100 BONUS",
    desc: "€100 in bonus cash with 5× wagering and a seven-day expiry.",
    artId: "art-coins",
    accentPos: "br",
    bigText: "€100",
    bigSize: "xl",
    subLabel: "BONUS CASH",
    cost: 7500,
    timerText: "Ends in 5d",
    stockPct: 55,
  },
  {
    id: "cash-250",
    category: "cash",
    displayMode: "typo",
    name: "€250 Bonus",
    title: "VIP CASH BONUS",
    headline: "€250 BONUS",
    desc: "€250 in bonus cash with 5× wagering. VIP members only.",
    tag: "VIP",
    tagClass: getTagClass("VIP"),
    artId: "art-coins",
    accentPos: "cn",
    bigText: "€250",
    bigSize: "xl",
    subLabel: "VIP CASH",
    cost: 17500,
    timerText: "Ends in 5d",
    stockPct: 30,
  },
  // Mystery chests (tier art)
  {
    id: "mystery-bronze",
    category: "mystery",
    displayMode: "illust",
    isWide: false,
    name: "Bronze Chest",
    title: "BRONZE CHEST",
    headline: "MYSTERY CHEST",
    desc: "A bronze chest reveals 10–50 free spins or €2–€10 in bonus cash. Plenty in stock.",
    artId: "art-bronze",
    cost: 500,
    timerText: "In stock",
    stockPct: 88,
    tier: "bronze",
    tierClass: "tier-bronze",
  },
  {
    id: "mystery-silver",
    category: "mystery",
    displayMode: "illust",
    isWide: false,
    name: "Silver Chest",
    title: "SILVER CHEST",
    headline: "MYSTERY CHEST",
    desc: "A silver chest reveals 50–150 free spins or €5–€20 in bonus cash. 23 chests left.",
    tag: "LIMITED",
    tagClass: getTagClass("LIMITED"),
    artId: "art-silver",
    cost: 1500,
    timerText: "Ends in 1d",
    stockPct: 23,
    tier: "silver",
    tierClass: "tier-silver",
  },
  {
    id: "mystery-gold",
    category: "mystery",
    displayMode: "illust",
    isWide: false,
    name: "Gold Chest",
    title: "GOLD CHEST",
    headline: "MYSTERY CHEST",
    desc: "A gold chest reveals 200–500 free spins or €25–€100 in bonus cash. 14 left.",
    tag: "HOT",
    tagClass: getTagClass("HOT"),
    artId: "art-gold",
    cost: 5000,
    timerText: "Ends in 1d",
    stockPct: 28,
    tier: "gold",
    tierClass: "tier-gold",
  },
  // Tournaments
  {
    id: "tour-drops",
    category: "tournaments",
    displayMode: "typo",
    name: "Drops & Wins",
    title: "DROPS & WINS",
    headline: "€2M MONTHLY",
    desc: "Daily prize drops on selected Pragmatic Play titles. Min bet €0.20.",
    artId: "art-ticket",
    accentPos: "tl",
    bigText: "€2M",
    bigSize: "",
    subLabel: "PRIZE POOL",
    cost: 1200,
    timerText: "Open daily",
    stockPct: 80,
  },
  {
    id: "tour-weekly",
    category: "tournaments",
    displayMode: "typo",
    name: "Weekly Race Entry",
    title: "WEEKLY RACE",
    headline: "€5,000 POOL",
    desc: "Entry to the weekly race. €5,000 split across the top 1,000 spots. Ends Sunday 23:59 UTC.",
    tag: "NEW",
    tagClass: getTagClass("NEW"),
    artId: "art-trophy",
    accentPos: "br",
    bigText: "€5K",
    bigSize: "xl",
    subLabel: "PRIZE POOL",
    cost: 1500,
    timerText: "Open all week",
    stockPct: 65,
  },
  {
    id: "tour-showdown",
    category: "tournaments",
    displayMode: "typo",
    name: "Slot Showdown",
    title: "SLOT SHOWDOWN",
    headline: "€8,000 POOL",
    desc: "Friday-to-Saturday slot showdown across all Pragmatic titles. Top 500 win.",
    artId: "art-trophy",
    accentPos: "tr",
    bigText: "€8K",
    bigSize: "xl",
    subLabel: "PRIZE POOL",
    cost: 1800,
    timerText: "Ends Sat",
    stockPct: 50,
  },
  {
    id: "tour-highroller",
    category: "tournaments",
    displayMode: "typo",
    name: "High Roller Cup",
    title: "HIGH ROLLER CUP",
    headline: "€15,000 POOL",
    desc: "Entry to the High Roller Cup. €15,000 prize pool, minimum bet €5.",
    artId: "art-ticket",
    accentPos: "bl",
    bigText: "€15K",
    bigSize: "xl",
    subLabel: "PRIZE POOL",
    cost: 3000,
    timerText: "Ends Sun",
    stockPct: 55,
  },
  // VIP locked item (cashback)
  {
    id: "vip-cashback",
    category: "vip",
    displayMode: "typo",
    name: "€1,000 Cashback",
    title: "REAL CASH",
    headline: "€1,000 CASHBACK",
    desc: "No wagering, paid as real cash. Available only to Diamond VIP members. You're at 33% to Diamond.",
    tag: "DIAMOND VIP ONLY",
    tagClass: getTagClass("DIAMOND VIP ONLY"),
    artId: "art-diamond",
    accentPos: "cn",
    bigText: "€1,000",
    bigSize: "sm",
    subLabel: "REAL CASH",
    cost: 50000,
    timerText: "Climb to Diamond",
    stockPct: 33,
    isLocked: true,
    lockReason: "Reach Diamond VIP to unlock — currently at 33%.",
    tier: null,
  },
];

export function getStoreMockState() {
  return {
    playerName: "Dennis",
    balance: 4250,
    rotationLabel: "Ends in 2h 14m",
    items: STORE_ITEMS_MOCK,
    isPreviewDemo: true,
  };
}

// Every item needs an SVG symbol id for <use>; the backend only sends one
// when the admin set it in the display JSON, so derive a default otherwise.
export function defaultArtId(category, tier) {
  if (category === "mystery") {
    if (tier === "bronze" || tier === "silver" || tier === "gold") {
      return `art-${tier}`;
    }
    return "art-vault";
  }
  if (category === "free-spins") return "art-spins";
  if (category === "tournaments") return "art-trophy";
  if (category === "vip") return "art-diamond";
  return "art-coins";
}

// Mystery redeem returns {label, sub} only; pick a reveal symbol from the label.
export function mapPrizeToReveal(prize) {
  if (!prize || typeof prize !== "object") return null;
  const label = String(prize.label || "").toUpperCase();
  let artId = "art-coins";
  if (label.includes("SPIN")) artId = "art-spins";
  else if (label.includes("RACE") || label.includes("ENTRY") || label.includes("TICKET")) artId = "art-ticket";
  else if (label.includes("VIP") || label.includes("PASS") || label.includes("LOUNGE")) artId = "art-crown";
  else if (label.includes("CASHBACK") || label.includes("DIAMOND")) artId = "art-diamond";
  return {
    artId,
    label: prize.label || "",
    sub: prize.sub || "",
  };
}

export function normalizeStoreData(payload) {
  // Only a malformed payload (never a real API response) falls back to the
  // preview fixture. A live payload is trusted as-is — its gaps become
  // "unknown", not the 4,250-coin demo balance.
  if (!payload || typeof payload !== "object") return getStoreMockState();

  const itemsRaw = Array.isArray(payload.items) ? payload.items : [];

  const balanceRaw =
    payload.balance ??
    payload.cloverCoins ??
    payload.clover_coins ??
    payload.clover_coins_balance;

  // Missing/blank balance on a live payload => null (unknown), so nothing
  // fabricates a spendable figure. The 4,250 fixture stays inside preview only.
  const balanceNum =
    balanceRaw != null && balanceRaw !== "" ? Number(balanceRaw) : null;
  const balance = Number.isFinite(balanceNum) ? balanceNum : null;

  const normalizedItems = itemsRaw.map((it) => {
    const category = it.category ?? "cash";
    const displayMode = getDefaultDisplayMode(category, it);
    const tag = it.tag ?? null;
    const tagClass = it.tagClass ?? getTagClass(tag);
    const tier = it.tier ?? null;

    return {
      ...it,
      id: it.id ?? it.item_id,
      category,
      displayMode,
      isWide: it.isWide ?? it.is_wide ?? false,
      isLocked: it.isLocked ?? it.is_locked ?? false,
      lockReason: it.lockReason ?? it.lock_reason ?? null,
      cost: Number(it.cost ?? it.price ?? 0) || 0,
      timerText: it.timerText ?? it.timer_text ?? "",
      stockPct: it.stockPct ?? it.stock_pct ?? 0,
      artId: it.artId ?? it.art_id ?? defaultArtId(category, tier),
      accentPos: it.accentPos ?? it.art_accent_pos ?? "cn",
      bigText: it.bigText ?? it.big_text ?? "",
      bigSize: it.bigSize ?? it.big_size_class ?? "",
      subLabel: it.subLabel ?? it.sub_label ?? "",
      tag,
      tagClass,
      tier,
      tierClass: it.tierClass ?? (tier ? `tier-${tier}` : ""),
      headline: it.headline ?? "",
      title: it.title ?? "",
      name: it.name ?? it.title ?? "",
      desc: it.desc ?? it.description ?? "",
    };
  });

  return {
    ...payload,
    items: normalizedItems,
    rotationLabel: payload.rotationLabel ?? payload.rotation_label ?? null,
    balance,
    isPreviewDemo: false,
  };
}

